export enum ScheduleMisfireHandling {
  DoNothing,
  IgnoreMisfires,
  FireAndProceed
}
